import { Badge, Box, Flex, Tag, Text } from '@chakra-ui/react';
import { GlobalSearchInquiryItem } from '@texas/api/endpoints/search/searchApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { useTranslation } from 'react-i18next';

interface Props {
  inquiry: GlobalSearchInquiryItem;
  onResultClick: () => void;
}

export function InquiryItem({ inquiry, onResultClick }: Props) {
  const { t } = useTranslation();
  return (
    <AngularNavLink
      to="variant.inquiry"
      navobj={{
        articleId: inquiry.articleId,
        variantId: inquiry.variantId,
      }}
      onClick={onResultClick}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={2}
      borderRadius="md"
      _hover={{
        bg: 'whiteAlpha.100',
        _light: { bg: 'blackAlpha.100' },
      }}
      textDecoration="none"
    >
      <Flex alignItems="center" gap={3}>
        <Box>
          <Text fontWeight="bold">{inquiry.formattedInquiryNumber}</Text>
          <Flex gap={2} fontSize="sm">
            <Text>{inquiry.articleItemCode}</Text>
            {inquiry.supplierName && (
              <>
                <Text color="gray.400">·</Text>
                <Text>{inquiry.supplierName}</Text>
              </>
            )}
          </Flex>
        </Box>
      </Flex>
      <Flex gap={2} align="center" flexShrink={0}>
        {inquiry.archived && (
          <Badge colorScheme="orange" size="sm">
            {t('general.archived')}
          </Badge>
        )}
        {inquiry.isMatrix && (
          <Tag size="sm" colorScheme="purple">
            {t('general.matrix')}
          </Tag>
        )}
        {inquiry.isVariable && (
          <Tag size="sm" colorScheme="teal">
            {t('general.variable')}
          </Tag>
        )}
      </Flex>
    </AngularNavLink>
  );
}
